import getWhiteLabelPrefix from "@/util/getWhiteLabelPrefix";

const GoogleTagManagerMixin = {
  mounted() {
    // if testing or on localhost, don't load google tag manager
    if (window.Cypress || document.URL.toLowerCase().includes("localhost")) {
      return undefined;
    }

    // Get the white label key prefix
    const whiteLabelKey = getWhiteLabelPrefix();

    // Get the empty script tag that will store the google tag manager code
    const tagManager = document.querySelector("script#google-tag-manager");

    if (whiteLabelKey) {
      // Get the client settings json file that is associated with the particular client
      const clientSettings = require("./clients/" +
        whiteLabelKey +
        "/Settings.json");

      // Triggering the load of google tag manager if the client has a google tag manager id available.
      if (clientSettings.googleTagManagerId) {
        tagManager.innerHTML =
          "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n" +
          "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n" +
          "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
          "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
          "})(window,document,'script','dataLayer','" +
          clientSettings.googleTagManagerId +
          "');";
      }
    }
  },
};

export default GoogleTagManagerMixin;
